import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1743f586")

_pushScopeId("data-v-1743f586")
const _hoisted_1 = {
  id: "main-content",
  style: {"position":"relative","overflow-x":"hidden","height":"100vh"}
}
const _hoisted_2 = {
  key: 0,
  class: "route-header"
}
const _hoisted_3 = { class: "main-content-component" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_NavBar = _resolveComponent("NavBar")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      id: "layout-header",
      class: _ctx.routeAdditionalClass ? _ctx.routeAdditionalClass : 'applayout',
      style: _ctx.headerStyle
    }, [
      (_ctx.routeName)
        ? (_openBlock(), _createBlock("h1", _hoisted_2, _toDisplayString(_ctx.routeName), 1))
        : _createCommentVNode("", true)
    ], 6),
    _createVNode("div", _hoisted_3, [
      (_ctx.isAuthenticated)
        ? (_openBlock(), _createBlock(_component_NavBar, {
            key: 0,
            id: "NavBarId"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view, null, {
        default: _withId(({ Component }) => [
          (_openBlock(), _createBlock(_KeepAlive, { include: ['ProviderTable', 'Orders'] }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              key: _ctx.$route.name || _ctx.$route.fullPath
            }))
          ], 1024))
        ]),
        _: 1
      })
    ])
  ]))
})